import { PageConfigService } from 'src/app/page-config.service';
import { Component,  HostListener, ViewChild} from '@angular/core';
import { MatSidenav} from '@angular/material/sidenav';
import { DisplayUserActionService} from "./display-user-action.service"
import { Subscription, Observable} from 'rxjs';
import { MatIconRegistry} from "@angular/material/icon";
import {  DomSanitizer} from "@angular/platform-browser";
import { HttpClientModule} from '@angular/common/http';
import {  AutorizationService} from "./api/autorization.service";
import {  UserApiService} from './user-api.service';
import {  Token} from './models/api_models/token';
import { IndexDbServiceService} from './db/index-db-service.service';
import {  ActivatedRoute,  Params} from '@angular/router';
import {  ThemeServiceService} from './theme-service.service';
import {  NotifiactionService} from './services/notifiaction.service';
import { MatSnackBar} from '@angular/material/snack-bar';
import {  CookieDialogComponent} from './dialog/cookie/cookie.component';
import { MatDialog} from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AngularFaviconService } from 'angular-favicon';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title : string;
  currentTheme: string = "theme-autopartage"
  themeList = ["my-theme", "light-theme"];

  @ViewChild('sidenav') sidenav: MatSidenav;
  public isLoad = false;

  favIcon: any = document.querySelector('#favIcon')

  constructor( 
    private ngxFavicon: AngularFaviconService,
    public translate: TranslateService,
    private displayUserActionService: DisplayUserActionService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private themeService: ThemeServiceService,
    private pageConfigService: PageConfigService,
    private autorizationService: AutorizationService,
    private userApiService: UserApiService,
    private indexDbServiceService: IndexDbServiceService,
    private notifiactionService: NotifiactionService,
    private userService: UserApiService,
    public dialog: MatDialog,
    private route: ActivatedRoute, private _snackBar: MatSnackBar) {


      translate.addLangs(['fr', 'en', 'es']);
      translate.setDefaultLang('fr');
  
      const browserLang = translate.getBrowserLang();
      translate.use(browserLang.match(/fr|en|es|ca/) ? browserLang : 'fr');





    this.matIconRegistry.addSvgIcon(
      "autopartage",
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.getIconAutopartage())
    );

    this.matIconRegistry.addSvgIcon(
      "recharge",
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.getIconRecharge())
    );
    this.matIconRegistry.addSvgIcon(
      "covoiturage",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/icon/solidirve-recherche.svg")
    );
    this.matIconRegistry.addSvgIcon(
      "partage-trajet",
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.getIconPartage())
    );
    this.matIconRegistry.addSvgIcon(
      "velo",
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.getIconVelo())
    );
    this.matIconRegistry.addSvgIcon(
      "trajet",
      this.domSanitizer.bypassSecurityTrustResourceUrl(this.getIconPartage())
    );
    notifiactionService.snackBarEvent$.subscribe(data => this.displayNewSnackBar(data));


  }

  openDialog(): void {
    const dialogRef = this.dialog.open(CookieDialogComponent, {
      width: '350px',
      data: null,
    });
  }

  displayNewSnackBar(message: string) {
    this._snackBar.open(message, "", {
      duration: 4000,
    });
  }

  GoLight() {
    this.currentTheme = "theme-recharge";

  }
  GoMy() {
    this.currentTheme = "light-theme";
  }
  private countdownEndRef: Subscription = null;
  public isMobileDivice;*
  setDevice() {
    if (this.innerWidth <= 768) {
      this.isMobileDivice = true;
      return;
    }
    this.sidenav.close();
    this.isMobileDivice = false;
  }

  public innerWidth: any;

  public closeSideNav(v) {
    this.sidenav.close();
  }

  public toggleSideNav(emit: boolean = false) {
    this.sidenav.toggle();
  }

  sub: Subscription;

 


  getIconAutopartage(){
   let host = location.host
   
   switch (host) {
  
    case `paysdelumbres.clem.mobi` : 
    case `www.paysdelumbres.clem.mobi` : 
    return '../assets/icon/VeloVoiture_Blanc.svg';

    case `mam.clem.mobi` : 
    case `www.mam.clem.mobi` : 
    return '../assets/icon/autopartage-recherche.svg';

    case `remiautopartage.clem.mobi` : 
    case `www.remiautopartage.clem.mobi` : 
    // case `localhost:4200` : 
    // case `devghiles.clem.mobi` : 
    return '../assets/img/Remi/autopartage-remi.svg';

     default:
        return '../assets/icon/autopartage-recherche.svg';
   }

  }

    getIconRecharge(){
      let host = location.host
   
   switch (host) {
  
    case `remiautopartage.clem.mobi` : 
    case `www.remiautopartage.clem.mobi` : 
    // case `localhost:4200` : 
    // case `devghiles.clem.mobi` : 
    return '../assets/img/Remi/recharge-remi.svg';

     default:
        return "../assets/icon/recharge-recherche.svg";
   }

  }

    getIconPartage(){
   let host = location.host
   
   switch (host) {
  
    case `remiautopartage.clem.mobi` : 
    case `www.remiautopartage.clem.mobi` : 
    // case `localhost:4200` : 
    // case `devghiles.clem.mobi` : 
    return '../assets/img/Remi/covoiturage-remi.svg';

     default:
        return "../assets/icon/trajet.svg";
   }

  }

  getIconVelo(){
    let host = location.host
    
    switch (host) {
   
     case `mam.clem.mobi` : 
     case `www.mam.clem.mobi` : 
     return '../assets/icon/velo-partage.svg';
 
      default:
        return '../assets/icon/velo-partage.svg';
    }
 
   }



  
  
  ngOnInit() {

    this.getHost()
    // console.log(this.route.snapshot.params);
    this.innerWidth = window.innerWidth;
    this.setDevice();
    // this.countdownEndRef = this.displayUserActionService.countdownEnd$.subscribe((value)=>{
    //   this.currentTheme = value.scssPrefix;
    // });

    this.indexDbServiceService.initDatabase();
    this.themeService.currentService.subscribe(item => {
     
      let host = location.host

      switch (host) {
        case `clem.mobi` : 
        case `www.clem.mobi` : 
        this.currentTheme =  `theme-${item}`
        break;

        case `mam.clem.mobi` : 
        case `www.mam.clem.mobi` : 
        // case `localhost:4200` : 
        this.currentTheme =  `theme-${item}-mam`

         case `remiautopartage.clem.mobi` : 
         case `www.remiautopartage.clem.mobi` : 
        //  case `localhost:4200` : 
        //  case `devghiles.clem.mobi` : 
        this.currentTheme =  `theme-${item}-remi`
        break;

        default:
          this.currentTheme =  `theme-${item}`
          
      }

    });
    this.autorizationService.login(null).subscribe(
      response => {
        this.isLoad = true;
        // console.log(response);

      },
      error => {
        // console.log(error);
      }
    )
    // if (!this.userService.isRGPDOK()) {
    //   this.openDialog();
    // }
  }
  ngOnDestroy() {
    this.displayUserActionService.destroy();
    this.countdownEndRef.unsubscribe();
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    this.setDevice();

  }



  getHost(){
    let host = location.host
   
      let url
      switch (host) {
        case `clem.mobi` : 
        case `www.clem.mobi` : 
          url = 'assets/json/homepage/Clem.json';
        break;

        case `456.bzh.clem.mobi` : 
        case `www.456.bzh.clem.mobi` : 
        case `bzh.clem.mobi` : 
          url = 'assets/json/homepage/BZH.json';
        break;

        case `mont-des-avaloirs.clem.mobi` : 
        case `www.mont-des-avaloirs.clem.mobi` : 
          url = 'assets/json/homepage/CCMA.json';
        break;

        case `paysdelumbres.clem.mobi` : 
        case `www.paysdelumbres.clem.mobi` : 
          url = 'assets/json/homepage/CCPL.json';
        break;

        case `autocampagne.clem.mobi` : 
        case `www.autocampagne.clem.mobi` : 
          url = 'assets/json/homepage/CCTDS.json';
        break;

        case `epernay.clem.mobi` : 
        case `www.epernay.clem.mobi` : 
          url = 'assets/json/homepage/epernay.json';
        break;

        case `lulu.clem.mobi` : 
        case `www.lulu.clem.mobi` : 
          url = 'assets/json/homepage/LULU.json';
        break;

        case `mouvngo.clem.mobi` : 
        case `www.mouvngo.clem.mobi` : 
          url = 'assets/json/homepage/mouvngo.json';
        break;

        case `myagicity.clem.mobi` : 
        case `www.myagicity.clem.mobi` : 
          url = 'assets/json/homepage/myagicity.json';
        break;

        case `paysdenexon-montsdechalus.clem.mobi` : 
        case `www.paysdenexon-montsdechalus.clem.mobi` : 
          url = 'assets/json/homepage/Nexon.json';
        break;

        case `virenormandie.clem.mobi` : 
        case `www.virenormandie.clem.mobi` : 
          url = 'assets/json/homepage/VNEM.json';
        break;

        case `roulevert.clem.mobi` : 
        case `www.roulevert.clem.mobi` : 
          url = 'assets/json/homepage/RouleVert.json';
        break;

        case `inli.clem.mobi` : 
        case `www.inli.clem.mobi` : 
          url = 'assets/json/homepage/inli.json';
        break;

        case `paris-saclay.clem.mobi` : 
        case `www.paris-saclay.clem.mobi` : 
          url = 'assets/json/homepage/saclay.json';
        break;

        case `azalys.clem.mobi` : 
        case `www.azalys.clem.mobi` : 
          url = 'assets/json/homepage/AZALYS.json';
        break;

        case `libeoautopartage.clem.mobi` : 
        case `www.libeoautopartage.clem.mobi` : 
          url = 'assets/json/homepage/libeo.json';
        break;

        case `tactic.clem.mobi` : 
        case `www.tactic.clem.mobi` : 
          url = 'assets/json/homepage/tactic.json';
        break;


        case `tadao.clem.mobi` : 
        case `www.tadao.clem.mobi` : 
          url = 'assets/json/homepage/tadao.json';
        break;

        case `loueise.clem.mobi` : 
        case `www.loueise.clem.mobi` : 
          url = 'assets/json/homepage/loueise.json';
        break;

        case `remiautopartage.clem.mobi` : 
        case `www.remiautopartage.clem.mobi` : 
          url = 'assets/json/homepage/remi.json';
        break;

        case `perivoitautopartage.clem.mobi` : 
        case `www.perivoitautopartage.clem.mobi` : 
          url = 'assets/json/homepage/perivoit.json';
        break;

        case `mam.clem.mobi` : 
        case `www.mam.clem.mobi` : 
          url = 'assets/json/homepage/mam.json';
        break;

        case `iledyeu.clem.mobi` : 
          url = 'assets/json/homepage/iledyeu.json';
        break;

        case `libelile.clem.mobi` : 
          url = 'assets/json/homepage/libelile.json';
        break;

        default:
          url = 'assets/json/homepage/Clem.json';
          
      }
     this.pageConfigService.getConfigCom(url).subscribe( x => {this.title = x.title; this.ngxFavicon.setFavicon(x.favicon)})
  
  }





// getHost(){
//   let host = location.host
 
//     let url
//     switch (host) {

//         case `lab.clem.mobi` : 
//           url = 'assets/json/homepage/Clem.json';
//         break;

//         case `lab.am-e.clem.mobi` : 
//           url = 'assets/json/homepage/AME.json';
//         break;

//         case `lab.cchvc.clem.mobi` : 
//           url = 'assets/json/homepage/CCHVC.json';
//         break;

//         case `lab.mont-des-avaloirs.clem.mobi` : 
//           url = 'assets/json/homepage/CCMA.json';
//         break;

//         case `lab.paysdelumbres.clem.mobi` : 
//           url = 'assets/json/homepage/CCPL.json';
//         break;

//         case `lab.autocampagne.clem.mobi` : 
//           url = 'assets/json/homepage/CCTDS.json';
//         break;

//         case `lab.epernay.clem.mobi` : 
//           url = 'assets/json/homepage/epernay.json';
//         break;

//         case `lab.lulu.clem.mobi` : 
//           url = 'assets/json/homepage/LULU.json';
//         break;

//         case `lab.mouvngo.clem.mobi` : 
//           url = 'assets/json/homepage/mouvngo.json';
//         break;

//         case `lab.myagicity.clem.mobi` : 
//           url = 'assets/json/homepage/myagicity.json';
//         break;

//         case `lab.paysdenexon-montsdechalus.clem.mobi` : 
//           url = 'assets/json/homepage/Nexon.json';
//         break;

//         case `lab.virenormandie.clem.mobi` : 
//           url = 'assets/json/homepage/VNEM.json';
//         break;
//          default:
//           url = 'assets/json/homepage/Clem.json';
//       }
//       this.pageConfigService.getConfigCom(url).subscribe( x => this.title = x.title)
   
//    }


  }
   
   

